import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={128}
      height={128}
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={38.1}
        y={25.4}
        width={19.05}
        height={6.35}
        rx={1.032}
        transform="rotate(90 38.1 25.4)"
        fill="#fff"
      />
      <rect
        x={101.6}
        y={25.4}
        width={19.05}
        height={6.35}
        rx={1.032}
        transform="rotate(90 101.6 25.4)"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.688 38.1h53.974v6.35c0 .877.711 1.587 1.588 1.587h6.35c.877 0 1.588-.71 1.588-1.587V38.1h13.255c.57 0 1.032.462 1.032 1.032v74.136c0 .57-.462 1.032-1.032 1.032H15.319c-.57 0-1.032-.462-1.032-1.032V39.132c0-.57.462-1.032 1.032-1.032h14.844v6.35c0 .877.71 1.587 1.587 1.587h6.35c.877 0 1.587-.71 1.587-1.587V38.1zm25.34 39.455c-2.819 0-4.647-1.333-5.41-3.62-.228-.723-.304-1.6-.304-2.59 0-.267.114-.42.343-.457l2.972-.305c.266-.038.457.076.457.381 0 1.067.038 1.41.152 1.79.267.8.8 1.258 1.753 1.258.952 0 1.524-.42 1.79-1.22.115-.342.153-.8.153-3.847 0-3.048-.038-3.467-.153-3.81-.266-.839-.876-1.22-1.79-1.22-.953 0-1.486.458-1.753 1.143-.114.267-.267.343-.571.343h-2.591c-.229 0-.381-.152-.381-.38V51.684c0-.228.152-.38.38-.38H70.44c.229 0 .381.152.381.38v2.782c0 .228-.152.38-.381.38h-7.01c-.153 0-.229.077-.229.23V61.4h.038c.572-.61 1.6-1.067 2.781-1.067 2.363 0 3.772 1.029 4.42 3.048.267.838.381 1.676.381 5.563 0 3.353-.114 4.305-.343 5.029-.762 2.286-2.59 3.581-5.448 3.581zM46.665 97.99c0 .134-.089.222-.222.222h-1.934c-.133 0-.222-.088-.222-.222v-5.978l-2.889-8.69c-.044-.134 0-.223.178-.223h1.956c.155 0 .222.067.266.223l1.69 5.845h.066l1.645-5.845c.044-.156.11-.223.266-.223h1.912c.178 0 .222.09.178.223l-2.89 8.69v5.978zm5.15.222c-.133 0-.221-.088-.221-.222V83.322c0-.134.088-.223.222-.223h6.2c.134 0 .223.09.223.223v1.711c0 .133-.09.222-.222.222h-3.912c-.089 0-.133.045-.133.134v3.978c0 .089.044.133.133.133h3.378c.133 0 .222.09.222.222v1.712c0 .133-.089.222-.222.222h-3.378c-.089 0-.133.044-.133.133v4.134c0 .09.044.134.133.134h3.912c.133 0 .222.088.222.222v1.711c0 .134-.09.222-.222.222h-6.201zm8.176 0c-.133 0-.2-.088-.177-.222l3.267-14.668c.044-.134.11-.223.244-.223h1.867c.133 0 .222.09.245.223l3.2 14.668c.022.134-.044.222-.178.222H66.57c-.156 0-.222-.088-.244-.222l-.6-3.045h-3l-.6 3.045c-.023.134-.09.222-.245.222h-1.89zm4.223-10.89l-1.111 5.623h2.245l-1.067-5.623h-.067zM78.657 97.99c.045.111 0 .222-.11.222h-2.068c-.133 0-.2-.044-.244-.155l-1.845-6.023h-1.133c-.09 0-.134.044-.134.133v5.823c0 .134-.089.222-.222.222h-1.934c-.133 0-.222-.088-.222-.222V83.322c0-.134.089-.223.222-.223h3.045c2.69 0 4.312 1.178 4.312 4.49 0 1.978-.667 3.222-1.8 3.867l2.133 6.534zm-5.4-8.067h.777c1.334 0 1.912-.534 1.912-2.334 0-1.778-.578-2.334-1.912-2.334h-.778c-.088 0-.133.045-.133.134v4.4c0 .089.045.133.133.133zm12.235-.467c1.978.778 2.756 1.844 2.756 4.422 0 2.979-1 4.534-3.867 4.534-2.445 0-3.711-1.31-3.778-3.956 0-.133.044-.222.178-.244l1.867-.311c.155-.022.244.066.244.2.067 1.6.534 2.222 1.556 2.222.956 0 1.422-.51 1.422-2.155 0-1.623-.31-2.156-1.489-2.623l-.911-.356c-2.09-.822-2.712-1.911-2.712-4.267 0-2.6 1.178-4.023 3.668-4.023 2.489 0 3.578 1.334 3.711 3.69 0 .133-.067.2-.2.244l-1.778.267c-.133.022-.244-.044-.244-.178-.045-1.245-.445-1.933-1.423-1.933-.933 0-1.378.577-1.378 1.822 0 1.4.267 1.822 1.467 2.29l.911.355z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.662 37.1H39.685v-3.175H94v3.179h-1.338V37.1zM30 40.402v4.447a1.587 1.587 0 01-.837-1.399v-3.048H30zm0-3.305v-3.172H9.557c-.57 0-1.032.462-1.032 1.032v74.136c0 .57.462 1.032 1.032 1.032h3.73V38.132c0-.57.462-1.032 1.032-1.032H27.75v-.003H30zm81.713-2.14V37.1H103v-3.175h7.681c.57 0 1.032.462 1.032 1.032z"
        fill="#fff"
      />
    </Svg>
  )
}

const SvgCalendar3White = styled(BaseComponent)`
  outline: none;
`
export default SvgCalendar3White
